import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-847fb922"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-address-book fas" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-plus fas" }, null, -1))
const _hoisted_3 = { class: "button-group" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Anterior")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Siguiente")
const _hoisted_6 = { class: "button-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_alert_list_component = _resolveComponent("alert-list-component")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_page_buttons_component = _resolveComponent("page-buttons-component")!
  const _component_alert_form_component = _resolveComponent("alert-form-component")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_contact_form_component = _resolveComponent("contact-form-component")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createVNode(_component_alert_list_component, {
        list: _ctx.alertsList,
        ref: "alertList"
      }, null, 8, ["list"])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_page_buttons_component, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_tooltip, {
            effect: "dark",
            content: _ctx.$t('label.contact'),
            placement: "left"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                class: "btn",
                type: "primary",
                size: "large",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openContactForm())),
                circle: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["content"]),
          _createVNode(_component_el_tooltip, {
            effect: "dark",
            content: _ctx.$t('btn.create'),
            placement: "left"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                class: "btn",
                type: "primary",
                size: "large",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openAlertFormDialog())),
                circle: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["content"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.showAlertForm,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.showAlertForm) = $event)),
        title: _ctx.$t(_ctx.alertForm?.id ? 'label.alertEdit' : 'label.alertCreate'),
        "destroy-on-close": "",
        "custom-class": "app-form"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_alert_form_component, {
            ref: "alertForm",
            id: _ctx.alertForm?.id,
            currentView: _ctx.currentView
          }, null, 8, ["id", "currentView"]),
          _createElementVNode("span", _hoisted_3, [
            _createVNode(_component_el_button, {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.closeAlertFormDialog()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("btn.cancel")), 1)
              ]),
              _: 1
            }),
            (_ctx.currentView >= 2)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goToPreviousView()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.currentView <= 2)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 1,
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goToNextView()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.currentView === 3)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 2,
                  type: "primary",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.saveAlertForm()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("btn.save")), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "title"]),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.showContactForm,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.showContactForm) = $event)),
        title: _ctx.$t('label.contactForm'),
        "destroy-on-close": "",
        class: "dialog-contact",
        "custom-class": "app-form"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_contact_form_component, { ref: "contactForm" }, null, 512),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.closeContactForm()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("btn.cancel")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.saveChanges()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("btn.save")), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "title"])
    ])
  ]))
}